export const required = value => (!Boolean(value)); /* valida selects */
//export const required = value => (Boolean(value) && value === undefined); /* valida selects */

export const isRequired = (val) => (!Boolean(val));

export const maxLength = max => value => value && value.length > max ? `Debe tener ${max} caracteres o menos` : undefined;

export const maxLength15 = maxLength(15);

export const minLength = min => value => value && value.length < min;

export const minLength2 = minLength(2);

export const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined;

export const minValue18 = minValue(18);

export const passwordMinVal = value => value && value.length < 8 ? 'Contraseña invalida' : undefined;

export const isEmail = (value) => !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value));

export const email = value => (value ? (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'E-mail inválido. ' : undefined):undefined);

export const tooOld = value => value && value > 65 ? 'You might be too old for this' : undefined;

export const alphaNumeric = value => value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters' : undefined;

export const phoneNumber = value => (value ? (!/^(0|[1-9][0-9]{9})$/i.test(value) ? 'Número de teléfono inválido.' : undefined):undefined);

export const isCurp = value => (value ? (!/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(value) ? 'CURP Inválida. ':undefined):undefined);

export const isRfc = value => (value ? (!/^[a-zA-Z]{3,4}([0-9]{2})(1[0-2]|0[1-9])([0-3][0-9])([a-zA-Z0-9]{3})$/.test(value) ? 'RFC Inválido':undefined):undefined);

export const isRfcMoral = value => (value ? (!/^[a-zA-Z]{3}([0-9]{2})(1[0-2]|0[1-9])([0-3][0-9])([a-zA-Z0-9]{3})$/.test(value) ? 'RFC Inválido':undefined):undefined);



// WEBPACK FOOTER //
// ./src/elements/field_validations.js